import { useMediaQuery } from './useMediaQuery';
import { useLocalStorage } from './useLocalStorage';
export function useHasSideMenu() {
    return useMediaQuery('(min-width: 540px)');
}
export function useCanPinMenu() {
    return useMediaQuery('(min-width: 960px) and (min-height: 540px)');
}
export function usePinMenu() {
    return useLocalStorage('pinMainMenu', true);
}
//# sourceMappingURL=menuHooks.js.map